<template>
  <div class="layout-detail content-wrapper bg-white dark:bg-darkblue-900  flex flex-col w-full relative">
    <slot name="header" />
    <article class="content flex flex-col flex-auto overflow-y-auto w-full">
      <div class="w-full md:w-11.5/12 lg:max-w-detail lg:mr-auto">
        <div class="px-4 lg:px-10">
            <slot name="main" />
        </div>
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail'
}
</script>
